import { getTheme } from '@fluentui/style-utilities';
import React from 'react';
import { ReactElement } from 'react';
import { QueueConfiguration } from '../../../services';
import { LiveEdit } from '../../liveedit/LiveEdit';

interface UxPreferencesTabProps {
  config: QueueConfiguration;
}

export const UxPreferencesTab = (props: UxPreferencesTabProps): ReactElement => {
  const { palette } = getTheme();

  return (
    <span
      className="ms-depth-4 rounded my-3 w-100 h-100"
      style={{
        backgroundColor: palette.white,
        maxWidth: '100%',
        display: 'block'
      }}
    >
      <LiveEdit config={props.config} />
    </span>
  );
};
